const work_skills = [
    {
        id: 1,
        company: "Frontend Skills",
        information: [
            "React.js",
            "Next.js",
            "Tailwind CSS",
            "Bootstrap",
            "MUI",   
        ],
    },
    {
        id: 2,
        company: "Backend Skills",
        
        information: [
            "Express.js",
            "Node.js",
            "RESTful API",
            "Flask"
        ],
    },
    {
        id: 3,
        company: "Programming Languages",
        information: [
            "JavaScript", "TypeScript", "Python", "R","Pyspark"
        ],
    },
    {
        id: 4,
        company: "Database Skills",
        information: [
            " MongoDB", "PostgreSQL","Vector Databases","Chromadb"
        ],
    },
    {
        id: 5,
        company: "Data Science",
        information: [
             "NumPy", "Pandas", "Matplotlib", "Seaborn", "Scikit-Learn","Tableau","Pytorch","Tensorflow"
        ],
    },
    {
        id: 6,
        company: "Version Control",
        information: [
            "AWS",
            "GITHUB",
            "Docker",
            "Streamlit"
        ],
    },
];

export default work_skills;
